<template>
  <div class="sign_in_box">
    <div class="signForm">
      <h3></h3>
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="ruleForm"
      >
        <el-form-item prop="username" class="item" label-width="0">
          <el-input
            type="text"
            v-model="ruleForm.username"
            autocomplete="true"
            placeholder="用户名"
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" class="item" label-width="0">
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            placeholder="密码"
            class="input"
            @change="submitForm"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item prop="authcode" class="item" label-width="0">
          <el-input
            type="text"
            v-model="ruleForm.authcode"
            autocomplete="off"
            placeholder="验证码"
            class="authcode"
            style="width:140px;"
          ></el-input>
          <AuthCode v-model="validCode" />
        </el-form-item> -->

        <div class="register text">
          <!-- <el-checkbox v-model="checked">自动登录</el-checkbox> -->
          <!-- <div  v-if="!isAdmin">
            <Contact />
            <nuxt-link to="/register">
              <p>注册账户</p>
            </nuxt-link>
          </div> -->
        </div>

        <!-- <div class="textBox text">
          <div>忘记密码</div>
        </div>-->
        <el-form-item class="btnBox" label-width="0">
          <el-button type="primary" @click="submitForm" :loading="loading" class="button">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="byteborder">@byteborder 字节边际</div>  -->
  </div>
</template>

<script>
import AuthCode from "@/components/AuthCode";
import { mapActions } from 'vuex';
import Cookie from 'js-cookie'
export default {
  props: ["isAdmin"],
  components: {
    AuthCode
  },
  data() {
    var validateUser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户"));
      } else {
        callback();
      }
    };
    // var validateCode = (rule, value, callback) => {
    //   if (value != this.validCode) {
    //     callback(new Error("验证码有误,请重新输入"));
    //   } else {
    //     callback();
    //   }
    // };
    var validatePass = (rule, value, callback) => {
      const passwordLimit = /^[a-zA-Z0-9]{6,18}$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      checked: false,
      validCode: "",
      ruleForm: {
        username: "",
        password: "",
        authcode: ""
      },
      rules: {
        username: [
          { validator: validateUser, required: true, trigger: "blur" }
        ],
        password: [
          { validator: validatePass, required: true, trigger: "blur" }
        ],
        // authcode: [{ validator: validateCode, required: true, trigger: "blur" }]
      }
    };
  },
  methods: {
    ...mapActions(['login']),
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let params = {
            account: this.ruleForm.username,
            password: this.ruleForm.password
          };
          this.$axios.post('/api/login/index',this.$qs.stringify(params)).then(res=>{
            loading.close();
              if(res.data.code==1){
                Cookie.set('token', res.data.data.token)
                Cookie.set('roleType', res.data.data.roleType)
                Cookie.set('avatar', res.data.data.avatar)  
                Cookie.set('name', res.data.data.name)  
                // this.$router.push('/index')
                if([1,2,5,7].includes(res.data.data.roleType)){
                  this.$router.push('/user')
                }else if([1,2,3].includes(res.data.data.roleType)){
                  this.$router.push('/customer')
                }else if(![7,8].includes(res.data.data.roleType)){
                  this.$router.push('/orderList')
                }else if([7,8].includes(res.data.data.roleType)){
                  this.$router.push('/informationList')
                }
                
              }
          })
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style >
.el-input__inner {
  /* border-radius: 20px; */
}

</style>

<style lang="scss" scoped>
.el-form-item{
  ::v-deep .el-form-item__content{
    width: 100%;
    .el-input{
      width: 100% !important;
    }
  }
}

.sign_in_box {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  justify-content: center;
  background: #16507f top center no-repeat;
  background-image: url('../../../static/barg.jpg');
  background-size: cover;
  .signForm {
    width: 440px;
    height: 320px;
    border-radius: 15px;
    background-color: white;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: 14px;
    h3 {
      font-size: 30px;
      font-weight: 400;
      color: rgba(128, 128, 128, 1);
    }
    .ruleForm {
      margin-top: 40px;
      width: 70%;
    }
    
    .textBox {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .btnBox {
      margin-top: 15px;
      .button {
        width: 100%;
        // border-radius: 20px;
      }
    }
    .text {
      color: #5175ea;
      cursor: pointer;
    }
    a {
      text-decoration: none;
      outline: none;
      color: inherit;
    }
  }
  .byteborder {
    position: absolute;
    bottom: 10px;
    color: #e5e5e5;
  }
  .item {
    display: flex;
    .input {
      // flex: 1;
      width: 140%;
    }
    .authcode {
      flex: 1;
    }
  }
}
.register {
  display: flex;
  margin-top: 30px;
  margin-bottom: 20px;
  div {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    a {
      margin-left: 10px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/Login/index.vue